import * as Yup from 'yup'
import { LANGUAGES, LANGUAGES_OPTION, SELECT_LANGUAGES } from '../../../../ReusableFormFields/LanguagesFields/fields'
import { languagesCreateValidation } from '../../../../../features/validations/languages'

export const initialLanguagesValues = {
  [LANGUAGES_OPTION]: SELECT_LANGUAGES,
  [LANGUAGES]: [
    {
      label: 'English',
      resource_name: 'languageConstants/1000',
      value: 1000
    }
  ]
}

export const validationSchema = Yup.object({
  ...languagesCreateValidation
})

export const transformLanguagesValuesToBE = values => {
  return values[LANGUAGES].map(({ resource_name }) => ({
    language: {
      language_constant: resource_name
    }
  }))
}
